/**
 * Used this component to added links or info into top right header
 * Mobile version: under social links
 */

import React from 'react';
import { UniversalLink } from '@plone/volto/components';
import { Icon } from 'iovisit-theme/components';
import { defineMessages, useIntl } from 'react-intl';
import config from '@plone/volto/registry';

const HeaderTopRightMore = () => {
  const rightLink = config.settings.iovisit.rightLink;

  return rightLink ? (
    <span className="iv--topright-link">
      <UniversalLink href={rightLink.url} className="iv--header-top-externallink"
          rel="noopener noreferrer"
          target="_blank">
        <Icon prefix="fas" icon="external-link-alt" className="icon" />
        {rightLink.text}
      </UniversalLink>
    </span>
  ) : (
    <></>
  );
};

export default HeaderTopRightMore;
